import Vue from 'vue';
import Router from 'vue-router';
import LoginService from './api/login-and-signup';
import store from './stores/store';

import { startSessionHelper } from './utils/startSessionHelper';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/request-password-reset-link',
      name: 'request-password-reset-link',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/calendar',
      name: 'calendar',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/calendar-daily',
      name: 'calendar-daily',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/cashflow-charts',
      name: 'cashflow-charts',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/exports',
      name: 'exports',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/upcoming-events',
      name: 'upcomingEvents',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/calendar-live-events',
      name: 'calendarLiveEvents',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/live-events',
      name: 'liveEvents',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/past-events',
      name: 'pastEvents',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/automated-emails',
      name: 'automatedEmails',
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/revenue',
      name: 'revenue',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/revenue-settings',
      name: 'revenue-settings',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/revenue-filter',
      name: 'revenue-filter',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/revenue-customer-lists',
      name: 'revenue-customer-lists',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/revenue-charts',
      name: 'revenue-charts',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/revenue-projections',
      name: 'revenue-projections',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/time',
      name: 'time',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/customers',
      name: 'customers',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/historical',
      name: 'historical',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/historical-details',
      name: 'historical-details',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/customers-delinquent',
      name: 'customers-delinquent',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/customers-recovered',
      name: 'customers-recovered',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/email-campaigns',
      name: 'email-campaigns',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/email-campaigns/:id',
      name: 'email-campaign-details',
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/create-email-campaign',
      name: 'create-email-campaign',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/expiring-cards',
      name: 'expiring-cards',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/payment-collection-form',
      name: 'payment-collection-form',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/payment-collection-snippet',
      name: 'payment-collection-snippet',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/profitkit-form',
      name: 'profitkit-form',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/profile',
      name: 'profile',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/team',
      name: 'team',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/team-registration/:id',
      name: 'team-registration',
      props: true, // accept params as props
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/referrals',
      name: 'referrals',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/referral-link/:id',
      name: 'referral-link',
      props: true, // accept params as props
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/integrations',
      name: 'integrations',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/notice',
      name: 'notice',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/payment',
      name: 'payment',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: {
        requiresAuth: false,
      },
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },
    {
      path: '/terms',
      name: 'terms',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/testimonials',
      name: 'testimonials',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/update-payment/:id',
      name: 'update-payment',
      props: true, // accept params as props
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/checkout/success',
      name: 'checkout-success',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/checkout/cancel',
      name: 'checkout-cancel',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/stripe-auth',
      name: 'stripe-auth',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/stripe-auth-profile',
      name: 'stripe-auth-profile',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/google-calendar-auth',
      name: 'google-calendar-auth',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/gmail-auth',
      name: 'gmail-auth',
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/feedback',
      name: 'feedback',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/resources/revenue-metrics-export',
      name: 'resources-revenue-metrics-export',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/resources/revenue-metrics-export-success',
      name: 'resources-revenue-metrics-export-success',
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '*',
      name: 'not-found',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./components/landing-page/NotFound.vue'),
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  let noSession = !store.getters.getVal('sessionExists');

  const { requiresAuth } = to.meta;
  if (store.getters.getTempVal('isDirty')) {
    store.commit('setTempState', {
      path: 'showModal',
      value: true,
    });
    store.commit('setTempState', {
      path: 'nextRoute',
      value: to.name,
    });
    next(false);
  } else if (noSession && !requiresAuth) {
    if (to.name !== 'login' && store.getters.getTempVal('routeAfterLogin') !== 'calendar') {
      // Lands on 1./payment -> 2./login -> 3./register or /
      store.commit('setTempState', {
        path: 'routeAfterLogin',
        value: 'calendar',
      });
    }
    next();
  } else if (noSession && requiresAuth) {
    store.commit('setTempState', {
      path: 'routeAfterLogin',
      value: to.name,
    });
    LoginService.checkAuth()
      .then(results => {
        const userAuth = results.data;
        // *** IF NOT LOGGED IN ON BACKEND SESSION, DESTROY FRONTEND SESSION + REDIRECT TO /LOGIN
        if (!userAuth || !userAuth.user) {
          next('/login');
        } else {
          startSessionHelper(userAuth, store); // Start Session
          next();
        }
      })
      .catch(err => {
        console.error(err);
        next('/login');
      });
  } else {
    next();
  }
});

export default router;
